import React from 'react';
import SplitTreatments from './SplitTreatments';
/**
 * High-Order Component for SplitTreatments.
 * The wrapped component receives all the props of the container,
 * along with the passed props from SplitTreatments (see ISplitTreatmentsChildProps).
 *
 * @param names list of Split names
 * @param attributes An object of type Attributes used to evaluate the splits.
 */
function withSplitTreatments(names, attributes) {
    return function withSplitTreatmentsHoc(WrappedComponent) {
        return (props) => {
            return (React.createElement(SplitTreatments, { names: names, attributes: attributes }, (splitProps) => {
                return (React.createElement(WrappedComponent, Object.assign({}, props, splitProps)));
            }));
        };
    };
}
export default withSplitTreatments;



// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio-react/es/withSplitTreatments.js